import { Injectable } from '@angular/core';
import { CarrierLookupModel } from 'app/generated/backend/party/api/carrier-lookup-model';
import { CarrierLookupHandlerService } from 'app/generated/backend/party/service/carrier-lookup-handler';
import { CachedEntityService } from 'app/_templates/CachedEntityService';
import { CoreCacheService } from '../cache/CoreCacheService';

@Injectable()
export class CoreCarrierLookupService extends CachedEntityService<CarrierLookupModel> {
	constructor(
		carrierLookupHandlerService: CarrierLookupHandlerService,
		cacheService: CoreCacheService
	) {
		super(carrierLookupHandlerService, cacheService.getCarriers());
	}
	transformItem(item: CarrierLookupModel): CarrierLookupModel {
		if (item) {
			item.match = '';
			if (item.name) {
				item.match += item.name.toLowerCase();
			}
			if (item.name) {
				item.match += ' ' + item.name.toLowerCase();
			}
		}
		return item;
	}
}
